import { Link } from "react-router-dom";
import { MapPin, Phone, EnvelopeSimple, Clock } from "@phosphor-icons/react";
import { useSettings } from "../../lib/api";

export const Footer = () => {
  const { data: s } = useSettings();

  return (
    <footer data-testid="site-footer" className="bg-panel border-t border-line">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3.5 mb-4">
            <img src="/brand/logo-icon.png" alt="FOSCHE logo" className="h-14 w-auto" />
            <span className="flex items-baseline gap-2">
              <span className="font-logo text-2xl text-ink">FOSCHE</span>
              <span className="font-logo text-[11px] text-[#6A7CB5]">LLC</span>
            </span>
          </div>
          <p className="font-mono-tech text-[11px] tracking-wide text-[#79a63f] mb-3">
            Building the world, One level at a time
          </p>
          <p className="text-sm text-sub leading-relaxed max-w-xs">
            Veteran-led construction, redevelopment, and infrastructure. Building the future and restoring the legacy
            of Detroit — with military precision.
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            {(s?.certifications || ["SDVOSB"]).map((c) => (
              <span key={c} className="font-mono-tech text-[10px] tracking-widest uppercase px-2.5 py-1 border border-line text-sub">
                {c}
              </span>
            ))}
          </div>
        </div>

        <div>
          <h4 className="overline-label mb-5">Company</h4>
          <ul className="space-y-3 text-sm">
            {[
              ["About", "/about"],
              ["Projects", "/projects"],
              ["Careers", "/careers"],
              ["Contact", "/contact"],
              ["Request a Quote", "/quote"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link to={to} className="text-sub hover:text-blueprint transition-colors">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="overline-label mb-5">Capabilities</h4>
          <ul className="space-y-3 text-sm">
            {["Construction", "Renovation", "Restoration", "Redevelopment", "Government Services", "Consulting"].map((x) => (
              <li key={x}>
                <Link to="/services" className="text-sub hover:text-blueprint transition-colors">
                  {x}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="overline-label mb-5">Headquarters</h4>
          <ul className="space-y-3 text-sm text-sub">
            <li className="flex gap-2.5">
              <MapPin size={16} className="text-blueprint mt-0.5 shrink-0" />
              <span data-testid="footer-address">{s?.address || "13401 W. Eight Mile Rd, Detroit, MI 48235"}</span>
            </li>
            <li className="flex gap-2.5 items-center">
              <Phone size={16} className="text-blueprint shrink-0" />
              <a data-testid="footer-phone" href={`tel:${s?.phone || "313-559-5058"}`} className="hover:text-blueprint">
                {s?.phone || "313-559-5058"}
              </a>
            </li>
            <li className="flex gap-2.5 items-center">
              <EnvelopeSimple size={16} className="text-blueprint shrink-0" />
              <a data-testid="footer-email" href={`mailto:${s?.email || "foster.terrya@fosche.us"}`} className="hover:text-blueprint break-all">
                {s?.email || "foster.terrya@fosche.us"}
              </a>
            </li>
            <li className="flex gap-2.5 items-center">
              <Clock size={16} className="text-blueprint shrink-0" />
              <span>{s?.hours || "Mon–Fri: 8:00 AM – 6:00 PM"}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-line">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono-tech text-[11px] tracking-wider text-sub">
            UEI: {s?.uei || "SAM.gov Registered"} · CAGE: {s?.cage || "Available Upon Request"}
          </p>
          <p className="text-[11px] text-sub">
            © {new Date().getFullYear()} FOSCHE, LLC. All rights reserved. ·{" "}
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-blueprint">
              Admin
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};
